import React, { useEffect } from 'react';
import { connect } from 'react-redux'
import './App.css';
import  WrappedStartPage from './StartPage';
import  VeranstalterPage  from './VeranstalterPage';
import VeranstaltungPage  from './components/VeranstaltungPage';
import Druckansicht from './components/Druckansicht/Druckansicht';
import FetchingInProgress from './components/FetchingInProgress';
import { appScreens } from './store/appNavigation/actions'
import ConfirmDialog from './components/ConfirmDialog';
import { applicationStarts } from './store/actions';
import HeaderAlert from './components/HeaderAlert';
import { ToastContainer }from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import QRCodeLinkToAppDialog from './components/QRCodeLinkToAppDialog';
import { applyDisplayMode, beobachteSystemFarbschema } from './displayMode';

function App(props) {
  const {currentScreen, applicationStarts, state, displayMode} = props
	useEffect(() => {
      applicationStarts(state)
  }, [applicationStarts, state]);

  // Setzt das Bootstrap-Theme nach der Wahl von der Startseite und folgt dem
  // Betriebssystem, solange dort "Automatisch" steht.
  const [istDunkel, setIstDunkel] = React.useState(() => applyDisplayMode(displayMode));
  useEffect(() => {
    setIstDunkel(applyDisplayMode(displayMode));
    return beobachteSystemFarbschema(() => setIstDunkel(applyDisplayMode(displayMode)));
  }, [displayMode]);
  let showScreen = null;
  switch(currentScreen){
    case appScreens.startPage:
      showScreen = <WrappedStartPage />
      break;
    case appScreens.veranstalterPage:
      showScreen = <VeranstalterPage />
      break;
    case appScreens.veranstaltungPage:
      showScreen = <VeranstaltungPage />
      break;
    case appScreens.druckansichtPage:
      showScreen = <Druckansicht />
      break;
  default:
        showScreen = <WrappedStartPage />
  }
  return (
    <>
    <FetchingInProgress/>
    <HeaderAlert/>
    <ConfirmDialog/>
    <QRCodeLinkToAppDialog/>
    <ToastContainer theme={istDunkel ? "dark" : "light"} />
      {showScreen}
    </>
  );
}
const putStateToProps = (state) => {
	return { 
    currentScreen : state.appNavigation.currentScreen,
    displayMode : state.appNavigation.displayMode
  }
}

const putActionsToProps = (dispatch, ownProps) => {
	return {
		applicationStarts : () => dispatch(applicationStarts(ownProps.state))
	}
};

export default connect(putStateToProps, putActionsToProps)(App);
